export enum LoginType {
  Grower = "grower",
  Credentials = "credentials",
}

export type TenantInfo = {
  support: {
    email: string;
    phone: string;
  };
  pages: {
    runNumber: {
      supportAlert: {
        text: string;
      };
    };
  };
};

export type SeasonalDatabase = {
  value: string;
  label: string;
  writable?: boolean;
};

export type LoginOptions = {
  tenantName: string;
  service: string;
};
